import React, { useState, useEffect } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
    Card,
    Grid,
    Collapse,
    IconButton,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import PlaceholderLoadingView from 'common/modules/loadingView/PlaceholderLoadingView';

const ResumeData = ({
    children,
    isCollapsable = true,
    isLoading,
    isOpen = false,
    title,
}) => {
    const [open, setIsOpen] = useState(isOpen);

    const handleClickToggle = (value) => setIsOpen(value);

    useEffect(() => {
        setIsOpen(isOpen);
    }, [isOpen]);

    const collapsable = isCollapsable ? (
        <IconButton>
            {open ? (
                <KeyboardArrowUpIcon fontSize="small" />
            ) : (
                <KeyboardArrowDownIcon fontSize="small" />
            )}
        </IconButton>
    ) : null;

    return (
        <Card>
            {isLoading && <PlaceholderLoadingView />}
            <Card.Header>
                <Grid
                    alignItems="center"
                    container
                    onClick={() =>
                        isCollapsable && !isLoading
                            ? handleClickToggle(!open)
                            : null
                    }
                >
                    <Grid>
                        <Typography variant="body2" fontWeight="bold">
                            {title}
                        </Typography>
                    </Grid>

                    <Grid sx={{ ml: 'auto' }}>{collapsable}</Grid>
                </Grid>
            </Card.Header>

            <Collapse in={open}>
                <Card.Body>{children}</Card.Body>
            </Collapse>
        </Card>
    );
};

ResumeData.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    isCollapsable: PropTypes.bool,
    isLoading: PropTypes.bool,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
};

export default ResumeData;
